<template>
  <ul class="navi navi-hover">
    <template v-for="(item, i) in languages">
      <li
        style="list-style-type: none"
        class="navi-item"
        :class="{ 'navi-item-active': isActiveLanguage(item.lang) }"
        :key="i"
      >
        <a
          href="#"
          class="navi-link ml-0"
          v-bind:data-lang="item.lang"
          v-on:click="selectedLanguage"
        >
          <!-- <span class="ml-0">
            <img
              v-if="item"
              width="20"
              height="20"
              class="rounded-sm mr-2 ml-1"
              :src="item.lang == 'ru' ?
                require('@/assets/images/ru.svg') : require('@/assets/images/uz.svg')"
              alt
            />
          </span> -->
          <!-- <span > -->
          <!-- <img :src="item.flag" alt="" /> -->
          <!-- </span> -->
          <span class="navi-text">{{ item.name }}</span>
        </a>
      </li>
    </template>
  </ul>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "KTDropdownLanguage",
  data() {
    return {
      languages: i18nService.languages
    };
  },
  methods: {
    selectedLanguage(e) {
      const el = e.target.closest(".navi-link");
      const lang = el.getAttribute("data-lang");

      i18nService.setActiveLanguage(lang);

      this.$emit(
        "language-changed",
        this.languages.find(val => {
          return val.lang === lang;
        })
      );

      window.location.reload();
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    }
  },
  computed: {
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  }
};
</script>

<style >
.navi .navi-item .navi-link {
    color: #464e5f;
}


.navi .navi-item .navi-link, .navi .navi-item .navi-link .navi-bullet .bullet, .navi .navi-item .navi-link .navi-icon, .navi .navi-item .navi-link .navi-icon i, .navi .navi-item .navi-link .navi-text {
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
}
.navi .navi-item .navi-link {
    color: #464e5f;
}
.navi .navi-item .navi-link, .navi .navi-item .navi-link .navi-text {
    font-size: 1rem;
}

.navi .navi-item .navi-link {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-bottom: 15px;
}
a, button {
  outline: 0!important;
}
a {
    color: #6993ff;
    text-decoration: none;
    background-color: transparent;
}
</style>